import { Component, OnInit } from '@angular/core';
import { FinDokumentStavka } from './fin-dokument-stavka';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalContainerService, BaseModalUpdateComponent, ModalService } from 'yt-ng-framework';

@Component({
  selector: 'yt-fin-dokument-stavka-modal-update',
  templateUrl: './fin-dokument-stavka-modal-update.component.html'
})
export class FinDokumentStavkaModalUpdateComponent extends BaseModalUpdateComponent<FinDokumentStavka> {

  constructor(
    protected modalContainerService: ModalContainerService<FinDokumentStavka>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService
){
    super(modalContainerService, activeModal,modalService);
}

  

}
